import { useState } from "react";

export const SEARCH_MODALS_NAMES = {
  BULK_SEARCH: "bulk-search",
  SHARE_QUERY: "share-query",
  ADD_FAVOURITE: "add-favourite",
  EDIT_FAVOURITE: "edit-favourite",
  HELP: "help",
  SEARCH: "search",
  SUGGESTIONS: "suggestions",
  QUICK_SEARCH: "quick-search",
  DELETE_FAVOURITE: "delete-favourite"
};

export type SearchModalsNamesType =
  typeof SEARCH_MODALS_NAMES[keyof typeof SEARCH_MODALS_NAMES];

const useSearchModals = () => {
  const [modalName, setModalName] = useState<SearchModalsNamesType | undefined>(
    undefined
  );

  const openModal = (name: SearchModalsNamesType) => {
    setModalName(name);
  };

  const closeModal = () => {
    setModalName(undefined);
  };

  const modalOpened = modalName !== undefined;

  return {
    modalOpened,
    modalName,
    openModal,
    closeModal
  };
};

export default useSearchModals;
